exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".official-img{width:31px;vertical-align:middle;border:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-514c721a!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-markdown-loader/_cache/cell-3.vue
// module id = 227
// module chunks = 0